export default "__VITE_ASSET__C01QT9dl__"